<template>
  <div class="card" :class="product.daydeal ? 'orange-border' : ''" v-if="product">
    <div class="card__image">
      <div class="card__image__inside">
        <a class="box-nav" :href="'/product/' + this.slugText(product.id + '/' + product.name)">
          <b-img :src="product.image" fluid :alt="product.name" />
        </a>
      </div>
    </div>
    <a class="box-nav" :href="'/product/' + this.slugText(product.id + '/' + product.name)">
      <div class="card__info"
           :class="{ 'bg-success': isProductPlentyInStock(product),
                     'bg-danger': !isProductInStock(product),
                     'bg-warning': isProductInStock(product) && !isProductPlentyInStock(product) }">
        <div v-if="product.preorder" class="d-flex justify-content-center">
          <div>{{ $t('messages.preorder') }}</div>
          <div class="position-relative">
            <font-awesome-icon icon="circle" class="text-white position-button"></font-awesome-icon>
            <b-button v-b-tooltip.hover :title="$t('messages.preorder_info')" class="ml-1 mr-1 noPadding noBackground position-relative">
              <font-awesome-icon icon="info-circle" class="red"></font-awesome-icon>
            </b-button>
          </div>
        </div>
        <div v-if="product.backorder" class="d-flex justify-content-center">
          <div>{{ $t('messages.backorder') }}</div>
          <div class="position-relative">
            <font-awesome-icon icon="circle" class="text-white position-button"></font-awesome-icon>
            <b-button v-b-tooltip.hover :title="$t('messages.backorder_info')" class="ml-1 mr-1 noPadding noBackground position-relative">
              <font-awesome-icon icon="info-circle" class="red"></font-awesome-icon>
            </b-button>
          </div>
        </div>
        <div v-if="!product.preorder && !product.backorder">
          <div v-if="isProductPlentyInStock(product)">
            {{ $t('messages.stock_in') }}
          </div>
          <div v-if="!isProductInStock(product)">
            {{ $t('messages.sold_out') }}
          </div>
          <div v-if="isProductInStock(product) && !isProductPlentyInStock(product)">
            {{ $t('messages.stock_almost_sold_out') }}
          </div>
        </div>
        <div class="promotion" v-if="product.daydeal">
          <div class="promotion__wrapper">
            <p>{{ $t('deal.week').toLowerCase() }}</p>
            <p :class="localeClass">{{ $t('deal.deal').toLowerCase() }}</p>
          </div>
        </div>
      </div>
    </a>
    <h1 class="card__title d-flex">
      <a class="box-nav w-100" :href="'/product/' + this.slugText(product.id + '/' + product.name)">
        {{ product.name }}
      </a>
      <div>
        <cart-button :product="product" :amount="1" v-if="isProductInStock(product)" />
      </div>
    </h1>
    <a class="box-nav" :href="'/product/' + this.slugText(product.id + '/' + product.name)">
      <div class="card__bottom">
        <div class="card__box-icons" v-if="product.preorder || product.backorder">
          <div class="box-icon green strong">
            <div class="box-icon-wrapper">
              <font-awesome-icon class="green" icon="calendar-alt"></font-awesome-icon>
            </div>
            <span>{{ translateMonth(product.expected_date) }}</span>
          </div>
        </div>
        <div class="card__price" v-if="product.price">
          <p>
            <span class="red strong mr-2" v-if="product.old_price"><del>€ {{ product.old_price | round(2) }}</del></span>
            <span class="green strong">€ {{ product.price | round(2) }}</span>
          </p>
        </div>
      </div>
    </a>
    <div class="clear"></div>
  </div>
</template>

<script>
import CartButton from '../CartButton'

import { defaultMixin } from '../../mixin/default'
import { productMixin } from '../../mixin/product'

export default {
  name: 'producttile',
  mixins: [ defaultMixin, productMixin ],
  components: { CartButton },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    localeClass: function () {
      return this.$i18n.locale
    }
  },
  methods: {
    navigateToProduct: function (product) {
      this.$router.push('/product/' + this.slugText(product.id + '/' + product.name))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .card {
    cursor: pointer;
  }

  .box-nav, .box-nav:hover {
    color: inherit;
    text-decoration: none;
    border: none;
  }

  .orange-border {
    border: 2px #DF815B solid;
    box-shadow: 0px 0px 20px #DF815B;
  }

  .card__info {
    height: 40px;
  }

  .promotion {
    float: right;
    margin: -45px 0px 0px;
    width: 60px;
    height: 60px;
    background: url('../../assets/discount.png');
    background-size: 100%;
    color: #FFFFFF;
    font-weight: bold;
    text-transform: uppercase;

    -webkit-transform: rotate(-20deg);
    -moz-transform: rotate(-20deg);
    -ms-transform: rotate(-20deg);
    -o-transform: rotate(-20deg);
    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  }

  .promotion .promotion__wrapper {
    margin-top: -3px;
  }

  .promotion .promotion__wrapper p {
    text-align: center;
  }

  .promotion .promotion__wrapper p.nl {
    font-size: 11px;
  }

  .promotion .promotion__wrapper p.en {
    font-size: 11px;
  }

  .promotion .promotion__wrapper p:first-child {
    margin-top: 15px;
    margin-bottom: -5px;
    font-size: 18px;
  }

  .card__title {
    height: 100%;
  }

  .card__bottom {
    display: flex;
    justify-content: space-between;
    padding: 0px;
  }

  .card__price {
    margin-left: auto;
  }

  @media screen and (min-width: 701px) {
    .card {
      cursor: pointer;
      height: 400px;
    }

    .card__bottom {
      position: absolute;
      bottom: 0px;
      width: 100%;
    }
  }

  .img-fluid {
    width: 100%;
  }

  .clear {
    clear: both;
  }

  .position-button {
    position: absolute;
    top: 4px;
    left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/ProductTile.vue